module.exports = __webpack_public_path__ + "img/donnees_dans_la_base.61419d04.png";